import type { ShapeType } from '@/lib/shapes/types/shape-type'

/**
 * Which creation tool owns pointer input on the canvas. A selected shape type wins over the Type
 * tool, so text creation is only on when no shape type is chosen.
 */
export function resolveToolModes({
  selectedShape,
  isPenToolActive,
  isTextToolActive,
}: {
  selectedShape: ShapeType | null
  isPenToolActive: boolean
  isTextToolActive: boolean
}) {
  const isInShapeCreationMode = Boolean(selectedShape)
  const isInPenToolMode = isPenToolActive
  const isInTextCreationMode = isTextToolActive && !isInShapeCreationMode

  return { isInShapeCreationMode, isInPenToolMode, isInTextCreationMode }
}
